<template>
  <div class="topInstallBar" v-if="show">
    <span class="w-[34px]" @click="show=false"></span>
    <div class="flex-1 flex-center">
      <Image :src v-if="src" class="w-full" alt="" />
    </div>
    <Installation v-slot="{ start }">
      <span class="w-[100px] h-full" @click="start"></span>
    </Installation>
  </div>
</template>

<script setup lang="ts">
import { useHomeBannersAndTexts } from "@/store";
import Installation from "@a/components/Installation/index.vue";
import { isInApp, isInPWA } from "@/env";

const show = ref(false);
const src = computed(() => useHomeBannersAndTexts().topDownload?.asset);

const route = useRoute();

const check = () => {
  // 只能在首页显示
  if (isInApp || isInPWA || route.name !== 'home') return;

  watch(src, (val) => {
    show.value = !!val;
  }, { immediate: true });
  
  watch(show, (val) => {
    document.documentElement.style.setProperty('--topInstallBar-height', val ? '4.4rem' : '0px')
  }, { immediate: true });
}

onMounted(() => {
  check()
})
</script>

<style lang="scss">
.topInstallBar {
  @apply flex w-full h-[44px] shadow-md bgs-[var(--topInstallBar-bg),center_top] sticky top-[var(--safe-top)] z-[99] bg-[var(--theme-green-dark)];
  box-shadow: 0px 2px 2px 2px var(--theme-green-dark);
}
</style>
